module.exports = __webpack_public_path__ + "img/kirovogradgaz.d8a8a4b3.png";